<template>

<div id="app">
      <Navbar/>
</div>
</template>

<script>

import Navbar from './components/Navbar';

export default {
  name: 'App',
  components: {
    Navbar
  }
}
</script>
